var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Savable } from '@/common/mixins/Savable';
import LabelControl from '@/common/components/LabelControl.vue';
import DateInput from '@/common/components/DateInput.vue';
import { monthYearDate, fullDate } from '@/common/validators/veevalidators';
import moment from "moment";
var DateInputRow = /** @class */ (function (_super) {
    __extends(DateInputRow, _super);
    function DateInputRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DateInputRow.prototype, "hasTitle", {
        get: function () {
            if (this.title) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputRow.prototype, "inTable", {
        get: function () {
            return !this.hasTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputRow.prototype, "output", {
        get: function () {
            var ref = this.title + '_output';
            return this.$refs[ref];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputRow.prototype, "selectedString", {
        get: function () {
            if (!this.value)
                return null;
            var selectedDate = moment(this.value);
            var str = "";
            if (this.fullDate) {
                str += selectedDate.day() + ". ";
            }
            str += this.$t("Months." + (selectedDate.month() + 1)).toString();
            str += " " + selectedDate.year();
            str += " " + String(this.$t("Selection.Selected")).toLowerCase() + ".";
            return str;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputRow.prototype, "selectedDate", {
        get: function () {
            return this.value
                ? (this.fullDate
                    ? moment(this.value).format("DD.MM.YYYY")
                    : moment(this.value).format("MM.YYYY"))
                : null;
        },
        set: function (selected) {
            /* selected is expected to be in format DD.MM.YYYY */
            if (selected === "" || selected === undefined || selected === null) {
                this.$emit("input", null);
                this.output.textContent = "";
                this.output.className = "d-none";
                return;
            }
            var validator = this.fullDate ? fullDate : monthYearDate;
            var inputValid = validator.validate(selected, []);
            if (!inputValid) {
                this.output.textContent = selected + " " + this.$t("Validation.NotSaved") + " " + this.$t("Validation.monthYearDate") + ". ";
                this.output.className = "d-table-cell";
                return;
            }
            var dateStr = this.fullDate
                ? moment(selected, "DD.MM.YYYY").format("YYYY-MM-DD")
                : moment(selected, "MM.YYYY").format("YYYY-MM");
            this.$emit("input", dateStr);
            this.output.textContent = "";
            this.output.className = "d-none";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "title", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "name", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "instructionsKey", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "placeholder", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DateInputRow.prototype, "required", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DateInputRow.prototype, "readOnly", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], DateInputRow.prototype, "rules", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DateInputRow.prototype, "labelledBy", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DateInputRow.prototype, "disabled", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DateInputRow.prototype, "fullDate", void 0);
    DateInputRow = __decorate([
        Component({
            name: 'DateInputRow',
            components: {
                LabelControl: LabelControl,
                DateInput: DateInput
            }
        })
    ], DateInputRow);
    return DateInputRow;
}(Mixins(Savable)));
export default DateInputRow;
